'use strict';
var Defaults = require('./index');
module.exports = Defaults.defaults;
